// Campus photo for /colleges/hamilton-college: CC0 1.0, by ProfessorGhostface, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHamilton_College_Chapel_in_the_Sun.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/hamilton-college/; credited under the photo.
const photo = {
    "slug": "hamilton-college",
    "alt": "The Hamilton College Chapel among spring trees on the main quad in Clinton, New York",
    "src": "/colleges/hamilton-college/campus-1600.webp",
    "srcSmall": "/colleges/hamilton-college/campus-800.webp",
    "srcMid": "/colleges/hamilton-college/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/hamilton-college/og.jpg",
    "title": "Hamilton College Chapel in the Sun",
    "author": "ProfessorGhostface",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHamilton_College_Chapel_in_the_Sun.jpg",
    "read": "2026-10-02"
};

export default photo;
